import React, { Component } from 'react';




import { translations } from '../i18n/translations';

export default class EditGoodsForm extends Component{

    constructor(props){
        super(props);

        this.state = {
            sections_list: [],
            show_goods_form: false,
            currency_rate: {}
        }
    }

    componentWillReceiveProps = (nextProps) =>{
        this.setState({
            currency_rate: nextProps.currency_rate,
            sections_list: nextProps.sections_list,
            show_goods_form: nextProps.show_goods_form
        })
    }
    
    toggleAddGoods = (e) =>{
        this.setState({ show_goods_form: !this.state.show_goods_form });
    }

    render(){

        let { show_goods_form, sections_list } = this.state

        return(
            <div className="clearfix goods-form">
            {
                show_goods_form ? 
                    <span>
                        <div className="col-sm-12">
                            <select 
                                name="sections_list"
                                className="form-control">

                                <option value="" >{ translations.select_section }</option>
                                {                                    
                                    sections_list.map((section, index)=>{

                                        return <option key={ index } value={ section.id }>{ section.name }</option>
                                    })
                                }
                            </select>
                        </div>

                        <div className="col-sm-12">
                            <textarea 
                                name="goods_description" 
                                className="form-control" 
                                rows="4"
                                placeholder="Describe your goods"></textarea>

                            <div className="input-group input-group-select">
                                <span className="input-group-addon">
                                    <select name="unit_of_measure" className="form-control">
                                        <option value="">- Unit of Measure -</option>
                                        <option value="UNIT">UNIT</option>
                                        <option value="KGS">KGS</option>
                                        <option value="LITRES">LITRES</option>
                                    </select>
                                </span>
                                <input 
                                    className="form-control" 
                                    type="text" 
                                    placeholder="Enter the quantity"
                                    name="goods_quantity" />
                            </div>
                            
                        </div>
                        <div className="col-sm-12">
                            <button 
                                style={{ marginRight: "1em" }}
                                className="btn btn-xs btn-success"
                                onClick={ this.props.addGoodsFn }>
                                <span className="glyphicon glyphicon-plus"></span>
                                { translations.add }
                            </button>
                        </div>
                    </span>
                : 
                    null
                }
                <div className="col-sm-3">
                {
                    !show_goods_form ?
                        <span className="btn btn-sm btn-success" onClick={ this.toggleAddGoods }>
                            <span className="glyphicon glyphicon-plus"></span> 
                            { translations.add_goods }
                        </span>
                    :
                        null
                }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EditGoodsForm.jsx